import React from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap'

import CustomButton from '../CustomButton'

import './CustomPopupModal.css'

function CustomModal({ headerText, isOpen, toggle, backdrop, className, buttons, children }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop={backdrop} className={`CustomPopupModal ${className}`}>
      <ModalHeader>{headerText}</ModalHeader>
      <ModalBody>
        <Row>
          <Col md='12'>{children}</Col>
        </Row>
      </ModalBody>
      {buttons ? (
        <ModalFooter>
          {buttons.length > 0
            ? buttons.map((button, index) => {
                return (
                  <CustomButton
                    key={index}
                    block={button.block}
                    className={button.className}
                    headerText=''
                    size={button.size}
                    disabled={button.disabled}
                    color={button.color}
                    onClick={button.onClick}
                    text={button.text}
                  />
                )
              })
            : null}
        </ModalFooter>
      ) : null}
    </Modal>
  )
}

CustomModal.propTypes = {
  headerText: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  className: PropTypes.string,
  buttons: PropTypes.array,
}

export default CustomModal
